<div class="callback-page">
  <div class="callback-card">
    @if (codeSent && !autoCloseFailed) {
      <div class="status-icon success">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h2>Connected!</h2>
      <p>Authorization sent back to YeeHro. This window will close automatically...</p>
    } @else if (codeSent && autoCloseFailed) {
      <div class="status-icon success">
        <mat-icon>check_circle</mat-icon>
      </div>
      <h2>Connected!</h2>
      <p>Authorization sent back to YeeHro — you can close this window. If your account isn't connected yet, copy the code below and paste it in YeeHro.</p>
      <div class="code-block">
        <code>{{ authCode }}</code>
      </div>
      <button mat-flat-button class="copy-btn" [cdkCopyToClipboard]="authCode" (click)="showConfirmCopy()">
        <mat-icon>content_copy</mat-icon>
        Copy Code
      </button>
    } @else if (authCode) {
      <div class="status-icon waiting">
        <mat-icon>hourglass_top</mat-icon>
      </div>
      <h2>Almost There</h2>
      <p>If this window doesn't close automatically, copy the code below and paste it in YeeHro.</p>
      <div class="code-block">
        <code>{{ authCode }}</code>
      </div>
      <button mat-flat-button class="copy-btn" [cdkCopyToClipboard]="authCode" (click)="showConfirmCopy()">
        <mat-icon>content_copy</mat-icon>
        Copy Code
      </button>
    } @else if (errorMessage?.length) {
      <div class="status-icon error">
        <mat-icon>error_outline</mat-icon>
      </div>
      <h2>Authorization Failed</h2>
      <p>{{ errorMessage }}</p>
      <p>Please close this window and try again from the app.</p>
    } @else {
      <div class="status-icon error">
        <mat-icon>error_outline</mat-icon>
      </div>
      <h2>Something Went Wrong</h2>
      <p>No authorization code was received. Please close this window and try again.</p>
    }
  </div>
</div>
